import { AppStateType } from '../rootReducer'

export const getToken = (state: AppStateType) => state.auth.token
export const IsLoggedIn = (state: AppStateType) => state.auth.isLoggedIn
